/**
 * Generate a HTML string for an icon.
 *
 * @param {string} name
 */
export default (name) => `<svg class="zb-icon zb-icon-${name}">
  <title>${name}</title>
  <use xlink:href="#zb-icon-${name}"></use>
</svg>
`
